"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButton = void 0;
const horizon_util_ts_tokens_1 = require("@daytrip/horizon-util-ts-tokens");
const styled_components_1 = __importDefault(require("styled-components"));
const Breakpoint_1 = require("../../utils/Breakpoint");
const Dimensions_1 = require("../../utils/Dimensions");
const transformBreakpointToCSSMediaQuery_1 = require("../../utils/transformers/transformBreakpointToCSSMediaQuery");
exports.StyledButton = styled_components_1.default.button `
    padding: ${Dimensions_1.Dimensions.d16};

    font-size: ${Dimensions_1.Dimensions.d16};
    font-weight: 600;
    line-height: 1;
    text-decoration: none;

    border: 0;
    border-radius: ${Dimensions_1.Dimensions.d8};

    color: ${horizon_util_ts_tokens_1.Colors.White};
    background-color: ${horizon_util_ts_tokens_1.Colors.Blue400};

    -webkit-appearance: none;
    appearance: none;
    cursor: pointer;

    transition: background-color 0.25s;

    ${(0, transformBreakpointToCSSMediaQuery_1.transformBreakpointToCSSMediaQuery)(Breakpoint_1.Breakpoint.sm, "up")} {
        font-size: ${Dimensions_1.Dimensions.d18};
    }

    :disabled {
        color: ${horizon_util_ts_tokens_1.Colors.White};
        background-color: ${horizon_util_ts_tokens_1.Colors.Grey200};

        cursor: not-allowed;
    }

    :not(:disabled):hover {
        background-color: ${horizon_util_ts_tokens_1.Colors.Blue600};
    }
`;
//# sourceMappingURL=Button.styles.js.map